

























import {Component, Vue} from "vue-property-decorator";
import myCard from "./components/solutionCard.vue";
import myTitle from "./components/myTitle.vue";

@Component({
  components: {
    myTitle,
    myCard
  },
})

export default class intelFurniture extends Vue {
  path = 'assets/solution/intelFurniture/';

  cardContent = [
    {src:this.path+'shebei.png',title:'设备维修难度大',text:'IT设备维修难度大，对工程师的能力要求高，非行业的专业工程师难以胜任'},
    {src:this.path+'tuandui.png',title:'服务团队效率低',text:'服务商接单慢、效率低，IT设备的问题会影响整个企业的正常运行，不能及时接单导致企业损失巨大'},
    {src:this.path+'zhiliang.png',title:'服务质量没保障',text:'传统电话报修效率低，很难全面了解企业提供的服务内容，客户体验差'},
    {src:this.path+'beijian.png',title:'备件管理不科学',text:'没有制定科学的备件管理计划，导致需要维修时备件缺货，临时调度成本高且影响设备维修进度'},
    {src:this.path+'jifei.png',title:'计费方式不合理',text:'服务商计费方式单一，企业不能根据自身需要的售后情况选择计费方式，增加了企业售后服务成本'},
    {src:this.path+'jixiao.png',title:'绩效考核不到位',text:'企业对服务人员的满意度无法清晰反馈，服务商不能做针对性改进，用户体验难以提高'},
  ];

  solutions = [
    {
      title:'服务网络遍布全国',text:'全国有350+服务站点，拥有约2000人的自有专业服务团队，服务人员兢兢业业，服务质量值得信赖，服务范围覆盖全国'
    },
    {
      title:'多渠道快速售后处理',text:'平台支持APP、微信、二维码、网页、电话等多种方式提交服务请求，系统统一处理工单，服务人员将第一时间接单，快速响应，及时处理'
    },
    {
      title:'灵活的计费方式',text:'平台提供多种计费方式，用户可选择台/年计费、人/天计费或是单次计费，根据需求进行选择，帮助企业节省售后成本'
    },
    {
      title:'科学化备件管理',text:'平台提供备件管理功能，让用户明确每一个备件的动向，通过对备件使用情况的多维度分析，制定出科学的备件管理计划'
    },
  ]
}
